import React from 'react';

import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';

const Nav: React.FC = () => {
  return (
    <>
      <DesktopNav />
      <MobileNav />
    </>
  );
};

export default Nav;
